import { isEmpty, isFunction, isNil } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UnsavedChangesAlert from "../components/common/UnsavedChangesAlert";
import RffFormChanges from "../components/finalForm/RffFormChanges";
import { useUnderwritingHook } from "../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../redux/actions/loanDrilldownActions";
import { loanPipelineClear } from "../redux/actions/loanPipelineActions";
import { loanFetchedDataLoanTermsSet } from "../redux/reducers/loanFetchedDataReducer";

const LoanDrilldownChangesForm = ({
  data,
  showFooter = false,
  formSpy = false,
  children,
  onSuccessFn,
  sx,
  borrowerId,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const dispatch = useDispatch();
  const { loading, updateLoanData, updateBorrower } = useUnderwritingHook();
  const [loanDrilldownInitialValues, setLoanDrilldownInitialValues] =
    useState(null);

  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const [formKey, setFormKey] = useState(0); // Key to force form re-initialization

  const initialValues = useMemo(() => {
    return data || loanDrilldown;
  }, [data, loanDrilldown]);

  const handleUpdateFieldNew = useCallback((changedData) => {
    if (borrowerId) {
      // console.log("Updating borrower data:", {
      //   borrowerId: borrowerId,
      //   loanId: loanDrilldown?._id,
      //   data: changedData,
      //   onSuccessFn: (response) => {
      //     dispatch(loanDrilldownSet(response));
      //     dispatch(loanPipelineClear());
      //   },
      // });
      // return;
      updateBorrower({
        borrowerId: borrowerId,
        loanId: loanDrilldown?._id,
        data: changedData,
        onSuccessFn: (response) => {
          dispatch(loanDrilldownSet(response));
          dispatch(loanPipelineClear());
          if (isFunction(onSuccessFn)) {
            onSuccessFn(response);
          }
        },
      });
      return;
    }
    // console.log("borrowerId", borrowerId);
    // return;
    updateLoanData({
      loanId: loanDrilldown?._id,
      data: changedData,
      onSuccessFn: (response) => {
        dispatch(loanDrilldownSet(response));
        if (!isEmpty(loanTerms)) {
          dispatch(loanFetchedDataLoanTermsSet(null));
        }
        dispatch(loanPipelineClear());
        // let the "loading" spinner turn off
      },
      onFailFn: () => {
        dispatch(loanDrilldownSet(loanDrilldown));
      },
    });
  }, []);

  useEffect(() => {
    if (isNil(loanDrilldownInitialValues)) {
      setTimeout(() => {
        setLoanDrilldownInitialValues(loanDrilldown);
        setFormKey((prev) => prev + 1); // Force form re-initialization
      }, 100);
    } else {
      setFormKey((prev) => prev + 1);
    }
  }, [loanDrilldown]);
  return (
    <RffFormChanges
      key={formKey}
      initialValues={initialValues}
      suppressFooter={!showFooter}
      sx={sx}
      loading={loading}
      formSpy={formSpy}
      onSubmit={handleUpdateFieldNew}
      hasChangesContent={
        showFooter ? null : (
          <UnsavedChangesAlert
            loading={loading}
            onCancel={() => {
              setLoanDrilldownInitialValues(loanDrilldownInitialValues);
              setFormKey((prev) => prev + 1);
            }}
          />
        )
      }
    >
      {children}
    </RffFormChanges>
  );
};

export default LoanDrilldownChangesForm;
